const initialState = () => ({
  caregivers: [],
})

const getters = {
  CAREGIVERS: state => state.caregivers,
}

const actions = {}

const mutations = {
  RESET_STATE (state, payload) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_CAREGIVERS (state, payload) {
      state.caregivers = payload
    },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
}
